"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToDateString = exports.numToString = void 0;
function numToString(v, precision = 6) {
    return typeof v === 'number'
        ? v.toFixed(precision)
        : Number(v).toFixed(precision);
}
exports.numToString = numToString;
function dateToDateString(v) {
    return v instanceof Date
        ? v.getFullYear().toString() +
            '-' +
            (v.getMonth() + 1).toString().padStart(2, '0') +
            '-' +
            v.getDate().toString().padStart(2, '0')
        : v;
}
exports.dateToDateString = dateToDateString;
//# sourceMappingURL=hashable.js.map